import React from 'react';

import Seo from '../components/seo/Seo';
import ContactHero from '../components/contact/ContactHero';
import ContactForm from '../components/contact/ContactForm';
import ContactInfo from '../components/contact/ContactInfo';

export default function Contact(): React.ReactElement {
  return (
    <>
      <Seo
        title="Contact Us - Ancient Engineering | Get a Quote | Zimbabwe"
        description="Contact Ancient Engineering for your engineering needs in Zimbabwe. Get quotes for Industrial Automation, Solar PV, Fabrication, and ICT & Security services. Email: Info@ancientengineering.co.zw"
        keywords="contact Ancient Engineering, engineering quote Zimbabwe, engineering consultation Zimbabwe, Ancient Engineering contact"
        ogTitle="Contact Us - Ancient Engineering"
        ogDescription="Contact Ancient Engineering for engineering solutions in Zimbabwe. Get quotes and consultations for all your industrial needs."
        canonical="https://www.ancientengineering.co.zw/contact"
      />
      <ContactHero />
      <ContactInfo />
      <ContactForm />
    </>
  );
}

